export function freeze<TObject extends unknown>(
  object: TObject,
  {
    freezer = Object.freeze,
    isFrozen = Object.isFrozen,
  }: { freezer?: typeof Object.freeze; isFrozen?: typeof Object.isFrozen } = {}
): TObject {
  if (object) {
    Object.values(object).forEach((value) => {
      if (value && typeof value === 'object' && !isFrozen(value)) {
        freeze(value, { freezer, isFrozen });
      }
    });

    freezer(object);
  }

  return object;
}
